import { render, staticRenderFns } from "./FormOphthalmic.vue?vue&type=template&id=7d5b0100&"
import script from "./FormOphthalmic.vue?vue&type=script&lang=js&"
export * from "./FormOphthalmic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports